import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { addAttendance, listAttendance, pushcreate, stuacademicyearlist, stuclasslist, studivisionlist, teacherview } from "../service/dashboard";
import moment from "moment";
import { toast } from "react-toastify";

const Addattendance = () => {
  const [alist, setAList] = useState([]);
  const [clist, setCList] = useState([]);
  const [slist, setSList] = useState([]);
  const [spath, setSPath] = useState("");
  const [spush, setSPush] = useState(true);
  useEffect(() => {
    teacherview(localStorage.getItem("UID")).then((res) => {
      if (res.status === true) {
        setSPath(res.data.spath);
      }
    })
    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
        }
        setCList(arr);
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
        }
        setSList(arr);
      }
    });

    const temp = new FormData();
    temp.append("academy_id", localStorage.getItem("academy"));
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        const sorted = [...res.data].sort((a, b) => Number(b.id) - Number(a.id));
        if (sorted.length > 0) {
          for (let i = 0; i < sorted.length; i++) {
            arr.push({
              value: sorted[i].id,
              label: sorted[i].aca_year,
            });
          }
        }
        setAList(arr);
        if (arr.length > 0) {
          setForm((prev) => ({ ...prev, acayear: arr[0].value }));
        }
      }
    });
  }, [])
  const [attendanceList, setAttendanceList] = useState([

  ]);

  const handleToggle = (id) => {
    setAttendanceList(prev =>
      prev.map(student =>
        student.id === id
          ? { ...student, status: student.status == 1 ? 0 : 1 }
          : student
      )
    );
  };

  const handleAllChange = (status) => {
    setAttendanceList(prev =>
      prev.map(student => ({ ...student, status }))
    );
  };
  const [form, setForm] = useState({
    acayear: "",
    class: "",
    section: "",
    time: "",
    dueDate: moment(new Date()).format("YYYY-MM-DD"),
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (form.acayear !== "" && form.class !== "" && form.section !== "" && form.dueDate !== "") {
      setAttendanceList([]);
      const temp = new FormData();
      temp.append("academy", localStorage.getItem("academy"));
      temp.append("year", form.acayear);
      temp.append("class", form.class);
      temp.append("section", form.section);
      temp.append("role", 4);
      listAttendance(temp).then((response) => {
        if (response.status === true) {
          const mappedData = response.data.map((student) => ({
            ...student,
            status: 1,
          }));
          // Sort boys first (alphabetical), then girls (alphabetical),
          // with any other gender last.
          const genderRank = (g) => {
            const val = (g || "").toString().trim().toLowerCase();
            if (val === "male") return 0;
            if (val === "female") return 1;
            return 2;
          };
          const updatedData = [...mappedData].sort((a, b) => {
            const rankDiff = genderRank(a.gender) - genderRank(b.gender);
            if (rankDiff !== 0) return rankDiff;
            return (a.student_name || "").localeCompare(b.student_name || "", undefined, {
              sensitivity: "base",
            });
          });
          setAttendanceList(updatedData);
        } else {
          toast.error(response.message);
        }
      });
    }
  }, [form.acayear, form.class, form.section, form.dueDate]);
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    const temp = new FormData();
    temp.append("role", 4);
    temp.append("date", form.dueDate);
    temp.append("time", form.time);
    temp.append("count", attendanceList.length);
    temp.append("year", form.acayear);
    temp.append("class", form.class);
    temp.append("section", form.section);
    temp.append("user_id", localStorage.getItem("UID"));
    for (let i = 0; i < attendanceList.length; i++) {
      temp.append("id_" + [i + 1], attendanceList[i].id);
      temp.append("status_" + [i + 1], attendanceList[i].status);
      temp.append("remark_" + [i + 1], '');
    }

    addAttendance(temp).then((res) => {
      if (res.status === true) {
        toast.success(res.message);

        // Send push notification (same as web attendance flow), gated by the checkbox
        if (spush) {
          const clsname = clist.find(item => item.value == form.class)?.label || "";
          const secname = slist.find(item => item.value == form.section)?.label || "";
          const roleMsg = "Attendance for class " + clsname + " section " + secname +
            " on " + form.dueDate + " ( " + form.time + " ) has been marked.";

          const temp1 = new FormData();
          temp1.append("title", "Student Attendance Alert");
          temp1.append("push_sent_role", 4);
          temp1.append("priority", "High");
          temp1.append("message", roleMsg);
          temp1.append("academy_id", localStorage.getItem("academy"));
          temp1.append("push_file", "");
          temp1.append("type", "Attendance");
          temp1.append("time", form.time);
          temp1.append("role_id", 4);
          temp1.append("date", form.dueDate);
          temp1.append("class_id", form.class);
          temp1.append("section_id", form.section);
          temp1.append("class_name", clsname);
          temp1.append("section_name", secname);
          attendanceList.forEach((item, index) => {
            temp1.append("student_ids[]", item.user_id || item.id);
            temp1.append("student_name_" + (index + 1), item.student_name || "");
            temp1.append("status_" + (index + 1), item.status == 0 ? "Absent" : "Present");
          });

          pushcreate(temp1).then((pres) => {
            if (pres && pres.status === true) {
              toast.success(pres.message);
            }
            navigate('/studentattendance');
          });
        } else {
          navigate('/studentattendance');
        }
      } else {
        toast.error(res.message);
      }
    });

  };

  const errorhandle = (ev) => {
    ev.target.src = require("../assets/images/placeholder.png");
    ev.target.onerror = null;
  };

  const presentCount = attendanceList.filter(s => s.status == 1).length;
  const absentCount = attendanceList.length - presentCount;

  return (
    <div id="mainpage">
      <div className="maincontent">
        <Header />

        <div className="moreheading">
          <Row className="row-sm">
            <Col xs={6} className="text-left align-self-end">
              <h4 className="morehead-text">Add Attendance</h4>
            </Col>
            {/* <Col xs={4} className="text-right align-self-end">
              <Link to={"/addhomework"} className="btn-outline-success green-btn btn-sm">
                <i className="fa-solid fa fa-plus-square"></i> Add
              </Link>
            </Col> */}
            <Col xs={6} className="text-right align-self-end">
              <Link to={"/studentattendance"} className="btn-outline-success red-btn btn-sm">
                <i className="fa-solid fa-hand-point-left"></i> Go Back
              </Link>
            </Col>

          </Row>
        </div>
        <div className="card-body">
          <form >
            {/* Due Date */}
            <div className="mb-3">
              <label className="form-label attachment">Academic Year <span>*</span></label>
              <select
                className="form-select"
                name="acayear"
                value={form.acayear}
                onChange={handleChange}
                required
              >

                <option value="" disabled>
                  Select Academic Year
                </option>
                {alist.map((item, i) => (
                  <option value={item.value} key={i}>
                    {item.label}
                  </option>
                ))}
              </select>
              {/* {subhome && form.year === "" && (
                <span className="text-danger">Please Select Academic Year</span>
              )} */}
            </div>

            <div className="mb-3">
              <label className="form-label attachment">Date <span>*</span></label>
              <input
                type="date"
                name="dueDate"
                className="form-control"
                value={form.dueDate}
                onChange={handleChange}
                required
              />
            </div>

            {/* Class */}
            <div className="mb-3">
              <label className="form-label attachment">Class <span>*</span></label>
              <select
                className="form-select"
                name="class"
                value={form.class}
                onChange={handleChange}
                required
              >
                <option value="">Select Class</option>
                {clist.map((item, i) => (
                  <option value={item.value} key={i}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Section */}
            <div className="mb-3">
              <label className="form-label attachment">Section <span>*</span></label>
              <select
                className="form-select"
                name="section"
                value={form.section}
                onChange={handleChange}
                required
              >
                <option value="">Select Section</option>
                {slist.map((item, i) => (
                  <option value={item.value} key={i}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Subject */}
            <div className="mb-3">
              <label className="form-label attachment">Time <span>*</span></label>
              <select
                className="form-select"
                name="time"
                value={form.time}
                onChange={handleChange}
              >
                <option value="">Select Time</option>
                <option value="Morning">Morning</option>
                <option value="Afternoon">Afternoon</option>
              </select>
            </div>
          </form>
        </div>
        {attendanceList.length != 0 &&
          <div className="container my-4">
            <div className="d-flex justify-content-center gap-4 mb-4">
              <div className="text-center bg-light p-3 rounded shadow-sm">
                <div className="text-success fw-bold fs-4">{presentCount}</div>
                <div>Present</div>
              </div>
              <div className="text-center bg-light p-3 rounded shadow-sm">
                <div className="text-danger fw-bold fs-4">{absentCount}</div>
                <div>Absent</div>
              </div>
            </div>

            <div className="mb-3 text-center">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="all"
                  id="allPresent"
                  defaultChecked
                  onClick={() => handleAllChange(1)}
                />
                <label className="form-check-label" htmlFor="allPresent">All Present</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="all"
                  id="allAbsent"
                  onClick={() => handleAllChange(0)}
                />
                <label className="form-check-label" htmlFor="allAbsent">All Absent</label>
              </div>
            </div>

            <table className="table table-bordered align-middle text-center">
              <thead className="table-light table-head-color">
                <tr>
                  <th>Photo</th>
                  <th>Name</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {attendanceList.map(student => (
                  <tr key={student.id}>
                    <td>
                      <img src={spath + student.photo} alt="student" width="40" height="40" className="rounded-circle" onError={errorhandle} />
                    </td>
                    <td>{student.student_name}</td>

                    <td>
                      <div className="form-check form-switch d-flex align-items-center justify-content-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={student.status == 1}
                          onChange={() => handleToggle(student.id)}
                        />
                        <span className={`ms-2 fw-bold ${student.status == 1 ? "text-success" : "text-danger"}`}>
                          {student.status == 1 ? "Present" : "Absent"}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="form-check d-flex justify-content-center align-items-center gap-2 mt-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="sendPush"
                checked={spush}
                onChange={(e) => setSPush(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="sendPush">
                Send Push Notification
              </label>
            </div>

            <div className="text-center mt-4">
              <button className="btn btn-primary add-homework-submit px-5" onClick={handleSubmit}>Confirm & Submit Attendance</button>
            </div>
          </div>
        }


      </div>
      <Footer />
    </div>
  );
};

export default Addattendance;
